export default __webpack_public_path__ + "static/media/3132 spice rack C top.e72c5179.png";